import React from 'react'

import Heroabt from './Heroabt/Heroabt'
import Employees from './Employees/Employees'
import Portfolio from './Portfolio/Portfolio'

import Director from './Director/Director'
import { Helmet } from 'react-helmet'
import Homeservice from './Homeservice/Homeservice'
import Clients from './Clients/Clients'
import Heronew from './Hero/Heronew'
import Hero from './Hero/Hero'

const SITE_URL = 'https://www.yeskondomedia.com'
const LOGO_URL = 'https://www.yeskondomedia.com/Fav.png'

const Home = () => {

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${SITE_URL}/#localbusiness`,
    "name": "Yeskondo Media Pvt Ltd",
    "alternateName": "Yeskondo Media",
    "description": "Best marketing company in Pune offering 360° marketing solutions — digital marketing, OOH media, BTL/ATL campaigns, transit media, film production, event management, and corporate gifting.",
    "url": SITE_URL,
    "logo": {
      "@type": "ImageObject",
      "url": LOGO_URL,
      "width": 512,
      "height": 512
    },
    "image": LOGO_URL,
    "telephone": "+91-XXXXXXXXXX",
    "email": "info@yeskondomedia.com",
    "priceRange": "$$",
    "currenciesAccepted": "INR",
    "paymentAccepted": "Cash, Credit Card, UPI",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Pune, Maharashtra",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "postalCode": "411001",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "18.5204",
      "longitude": "73.8567"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:30",
        "closes": "18:30"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "10:00",
        "closes": "16:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/yeskondomedia",
      "https://www.instagram.com/yeskondomedia",
      "https://www.linkedin.com/company/yeskondomedia",
      "https://twitter.com/yeskondomedia"
    ],
    "areaServed": {
      "@type": "City",
      "name": "Pune"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Marketing Services",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Digital Marketing" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "OOH Media Advertising" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "ATL Media Services" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "BTL Media Services" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Transit Media Advertising" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Event Management" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Film Production" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Corporate Gifting" } }
      ]
    }
  }

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MarketingAgency",
    "@id": `${SITE_URL}/#organization`,
    "name": "Yeskondo Media Pvt Ltd",
    "url": SITE_URL,
    "logo": {
      "@type": "ImageObject",
      "url": LOGO_URL,
      "width": 512,
      "height": 512
    },
    "foundingDate": "2018",
    "description": "Yeskondo Media Pvt Ltd is the best marketing company in Pune providing end-to-end advertising and marketing services including digital marketing, OOH, BTL, ATL, transit media, event management, and more.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "info@yeskondomedia.com",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi", "Marathi"]
    },
    "sameAs": [
      "https://www.facebook.com/yeskondomedia",
      "https://www.instagram.com/yeskondomedia",
      "https://www.linkedin.com/company/yeskondomedia",
      "https://twitter.com/yeskondomedia"
    ]
  }

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    "url": SITE_URL,
    "name": "Yeskondo Media Pvt Ltd",
    "description": "Best Marketing Company in Pune — Yeskondo Media offers 360° marketing solutions.",
    "publisher": {
      "@id": `${SITE_URL}/#organization`
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${SITE_URL}/?s={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  }

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": `${SITE_URL}/#breadcrumb`,
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": SITE_URL
      }
    ]
  }

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${SITE_URL}/#webpage`,
    "url": SITE_URL,
    "name": "Best Marketing Company in Pune | Yeskondo Media Pvt Ltd",
    "isPartOf": { "@id": `${SITE_URL}/#website` },
    "about": { "@id": `${SITE_URL}/#organization` },
    "description": "Yeskondo Media Pvt Ltd is the best marketing company in Pune. We provide digital marketing, OOH advertising, BTL/ATL campaigns, transit media, film production, event management & corporate gifting services.",
    "breadcrumb": { "@id": `${SITE_URL}/#breadcrumb` },
    "inLanguage": "en-IN",
    "potentialAction": [
      {
        "@type": "ReadAction",
        "target": [SITE_URL]
      }
    ]
  }

  return (
    <>
      <Helmet>
        {/* ── Primary Meta Tags ── */}
        <html lang="en" />
        <title>Best Marketing Company in Pune | Yeskondo Media Pvt Ltd</title>
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content="Yeskondo Media Pvt Ltd Best marketing company in Pune. We deliver 360° marketing solutions: digital marketing, OOH media, BTL/ATL campaigns, transit media, event management, film production & corporate gifting."
        />
        <meta
          name="keywords"
          content="best marketing company in pune, marketing agency in pune, digital marketing agency pune, advertising agency pune, OOH media pune, BTL ATL marketing pune, event management pune, Yeskondo Media, 360 degree marketing pune, brand promotion pune"
        />
        <meta name="author" content="Yeskondo Media Pvt Ltd" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta name="googlebot" content="index, follow" />
        <meta name="theme-color" content="#1a1a2e" />

        {/* ── Canonical URL ── */}
        <link rel="canonical" href={SITE_URL} />

        {/* ── Open Graph / Facebook / WhatsApp ── */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Yeskondo Media Pvt Ltd" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:url" content={SITE_URL} />
        <meta
          property="og:title"
          content="Best Marketing Company in Pune | Yeskondo Media Pvt Ltd"
        />
        <meta
          property="og:description"
          content="Yeskondo Media Pvt Ltd — Best marketing company in Pune. 360° marketing: digital marketing, OOH media, BTL/ATL campaigns, transit media, event management, film production & corporate gifting."
        />
        <meta property="og:image" content={LOGO_URL} />
        <meta property="og:image:secure_url" content={LOGO_URL} />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />
        <meta property="og:image:alt" content="Yeskondo Media Pvt Ltd — Best Marketing Company in Pune" />

        {/* ── Twitter Card ── */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@yeskondomedia" />
        <meta name="twitter:creator" content="@yeskondomedia" />
        <meta
          name="twitter:title"
          content="Best Marketing Company in Pune | Yeskondo Media Pvt Ltd"
        />
        <meta
          name="twitter:description"
          content="Yeskondo Media Pvt Ltd — Best marketing company in Pune. Digital marketing, OOH, BTL/ATL, transit media, events & more."
        />
        <meta name="twitter:image" content={LOGO_URL} />
        <meta name="twitter:image:alt" content="Yeskondo Media Pvt Ltd Logo" />

        {/* ── Geo & Language ── */}
        <meta name="geo.region" content="IN-MH" />
        <meta name="geo.placename" content="Pune, Maharashtra" />
        <meta name="geo.position" content="18.5204;73.8567" />
        <meta name="ICBM" content="18.5204, 73.8567" />
        <meta httpEquiv="content-language" content="en-IN" />

        {/* ── Favicon & Icons ── */}
        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/Fav.png" />
        <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />

        {/* ── Preconnect for performance ── */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://www.google-analytics.com" />

        {/* ── JSON-LD Structured Data ── */}
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(webSiteSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>
      </Helmet>

      <Hero />
      <Heroabt />
      <Homeservice />
      <Employees />
      <Portfolio />
      <Director />
      <Clients />
    </>
  )
}

export default Home